const UitkCardContentSectionBorderMap = [
  ["top", "block-start"],
  ["right", "inline-end"],
  ["bottom", "block-end"],
  ["left", "inline-start"]
];
export const UitkCardContentSectionBorders = new Map(UitkCardContentSectionBorderMap);
const UitkCardContentSectionPaddingMap = [
  ["blockstart", "block-start"],
  ["blockend", "block-end"],
  ["inlinestart", "inline-start"],
  ["inlineend", "inline-end"]
];
export const UitkCardContentSectionPaddings = new Map(UitkCardContentSectionPaddingMap);
const UitkCardTagMap = [
  ["article", "article"],
  ["aside", "aside"],
  ["div", "div"],
  ["footer", "footer"],
  ["header", "header"],
  ["section", "section"],
  ["ul", "ul"],
  ["ol", "ol"],
  ["li", "li"]
];
export const UitkCardTags = new Map(UitkCardTagMap);
export var UitkCardPlaceholderStartPhases = /* @__PURE__ */ ((UitkCardPlaceholderStartPhases2) => {
  UitkCardPlaceholderStartPhases2["light"] = "light";
  UitkCardPlaceholderStartPhases2["dark"] = "dark";
  return UitkCardPlaceholderStartPhases2;
})(UitkCardPlaceholderStartPhases || {});
const UitkCardPlaceholderAspectRatioMap = [
  ["r1-1", "ratio-1-1"],
  ["r1-2", "ratio-1-2"],
  ["r1-3", "ratio-1-3"],
  ["r1-4", "ratio-1-4"],
  ["r1-5", "ratio-1-5"],
  ["r1-6", "ratio-1-6"]
];
export const UitkCardPlaceholderAspectRatios = new Map(UitkCardPlaceholderAspectRatioMap);
const UitkCardAspectRatioMap = [
  ["r1-1", "ratio-1-1"],
  ["r1-2", "ratio-1-2"],
  ["r1-3", "ratio-1-3"],
  ["r1-4", "ratio-1-4"],
  ["r1-5", "ratio-1-5"],
  ["r1-6", "ratio-1-6"]
];
export const UitkCardAspectRatios = new Map(UitkCardAspectRatioMap);
const UitkCardRoundCornersMap = [
  ["top-right", "top-right"],
  ["top-left", "top-left"],
  ["bottom-right", "bottom-right"],
  ["bottom-left", "bottom-left"],
  ["all", "all"]
];
export const UitkCardRoundCorners = new Map(UitkCardRoundCornersMap);
const UitkCardFeaturedHeaderTitleTagMap = [
  ["h2", "h2"],
  ["h3", "h3"],
  ["h4", "h4"],
  ["h5", "h5"],
  ["h6", "h6"],
  ["p", "p"]
];
export const UitkCardFeaturedHeaderTitleTags = new Map(UitkCardFeaturedHeaderTitleTagMap);
